// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--qAx0q","image":"_7a3fb80146--image--tfctd","title":"_7a3fb80146--title--dZd34","description":"_7a3fb80146--description--C2gKE"};